/**
 * unifiedBetCardStyles.js — static StyleSheet extracted from UnifiedBetCard.jsx
 * (god-file decomposition). Purely presentational constants; no logic.
 */

import { StyleSheet, Platform } from 'react-native';

export const styles = StyleSheet.create({
    card: {
        width: '100%',
        alignSelf: 'stretch',
        borderRadius: 16,
        overflow: 'hidden',
        marginBottom: 12,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.08)',
        ...(Platform.OS === 'web' ? {
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        } : {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.3,
            shadowRadius: 10,
            elevation: 8,
        }),
    },
    cardSelected: {
        borderColor: 'rgba(99, 102, 241, 0.5)',
        borderWidth: 2,
    },
    cardSGP: {
        borderColor: 'rgba(139, 92, 246, 0.4)',
        borderWidth: 2,
    },
    cardLive: {
        borderColor: 'rgba(34, 197, 94, 0.5)',  // ⭐ GREEN for LIVE (#22C55E)
        borderWidth: 2,
    },
    cardEnded: {
        opacity: 0.6,
    },
    // Two-column layout
    twoColumnLayout: {
        flexDirection: 'row',
        position: 'relative',
    },
    leftColumn: {
        flex: 1,
        minWidth: 0,
        paddingRight: 280, // Reserve space for absolute right column (wider on desktop)
    },
    rightColumn: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        width: 280, // Wider on desktop for better readability
        borderLeftWidth: 1,
        borderLeftColor: 'rgba(255,255,255,0.08)',
        backgroundColor: 'rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column',
    },
    
    // SGP Badge
    sgpBadgeGradient: {
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 8,
    },
    sgpBadgeText: {
        color: '#fff',
        fontSize: 11,
        fontWeight: '800',
        letterSpacing: 1,
    },
    
    // Header
    header: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: 16,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.06)',
    },
    photoContainer: {
        width: 52,
        height: 52,
        borderRadius: 26,
        overflow: 'hidden',
        backgroundColor: 'rgba(255,255,255,0.1)',
        marginRight: 12,
        // ⭐ Web fix: Ensure container doesn't duplicate/stretch image
        ...(Platform.OS === 'web' ? {
            position: 'relative',
            flexShrink: 0,
        } : {}),
    },
    photo: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover',
        // ⭐ Web fix: Proper image scaling to prevent warped/layered appearance
        ...(Platform.OS === 'web' ? {
            objectFit: 'cover',
            objectPosition: 'center',
        } : {}),
    },
    teamLogosSmall: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
    },
    teamLogoSmall: {
        width: 22,
        height: 22,
        borderRadius: 4,
    },
    initialsContainer: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(99, 102, 241, 0.3)',
    },
    initialsText: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '700',
    },
    headerInfo: {
        flex: 1,
        paddingRight: 12,
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
    },
    title: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '700',
    },
    description: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 13,
        marginTop: 4,
    },
    dateTimeRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginTop: 8,
        flexWrap: 'wrap',
    },
    // ⭐ Status Badge Styles (LIVE, SOON, UPCOMING, FINAL)
    statusBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
        gap: 4,
    },
    statusBadgeText: {
        fontSize: 10,
        fontWeight: '700',
        letterSpacing: 0.5,
    },
    liveDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: '#22C55E',  // ⭐ GREEN for LIVE
    },
    dateText: {
        color: 'rgba(162, 89, 255, 0.95)',
        fontSize: 12,
        fontWeight: '600',
    },
    timeText: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 12,
        fontWeight: '500',
    },
    noDateText: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 11,
        fontStyle: 'italic',
    },
    liveBadge: {
        backgroundColor: 'rgba(34, 197, 94, 0.2)',  // ⭐ GREEN for LIVE
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
    },
    liveBadgeText: {
        color: '#22C55E',  // ⭐ GREEN for LIVE
        fontSize: 10,
        fontWeight: '700',
    },
    evContainer: {
        position: 'absolute',
        top: 16,
        right: 16,
        alignItems: 'center',
    },
    evValue: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 18,
        fontWeight: '700',
    },
    evPositive: {
        color: '#10B981',
    },
    evNegative: {
        color: '#EF4444',
    },
    oddsPositive: {
        color: '#10B981',
    },
    oddsNegative: {
        color: '#EF4444',
    },
    evLabel: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 10,
        fontWeight: '600',
    },
    
    // Main/Alt Badge
    mainAltBadge: {
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 4,
    },
    mainBadge: {
        backgroundColor: '#2E7D32',
    },
    altBadge: {
        backgroundColor: '#E65100',
    },
    mainAltBadgeText: {
        color: '#fff',
        fontSize: 9,
        fontWeight: '800',
        letterSpacing: 0.5,
    },
    // 🏥 Injury Badge Styles
    injuryBadge: {
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 4,
        backgroundColor: 'rgba(251, 191, 36, 0.2)',
        borderWidth: 1,
        borderColor: 'rgba(251, 191, 36, 0.5)',
    },
    injuryBadgeOut: {
        backgroundColor: 'rgba(239, 68, 68, 0.2)',
        borderColor: 'rgba(239, 68, 68, 0.6)',
    },
    injuryBadgeDoubtful: {
        backgroundColor: 'rgba(239, 68, 68, 0.15)',
        borderColor: 'rgba(239, 68, 68, 0.4)',
    },
    injuryBadgeQuestionable: {
        backgroundColor: 'rgba(251, 191, 36, 0.2)',
        borderColor: 'rgba(251, 191, 36, 0.5)',
    },
    injuryBadgeDayToDay: {
        backgroundColor: 'rgba(251, 191, 36, 0.15)',
        borderColor: 'rgba(251, 191, 36, 0.4)',
    },
    injuryBadgeText: {
        color: '#fff',
        fontSize: 9,
        fontWeight: '700',
        letterSpacing: 0.5,
    },
    sportsbookBadge: {
        backgroundColor: 'rgba(162, 89, 255, 0.2)',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(162, 89, 255, 0.5)',
    },
    sportsbookBadgeText: {
        color: 'rgba(162, 89, 255, 0.95)',
        fontSize: 10,
        fontWeight: '700',
    },
    
    // Price Section
    priceSection: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        backgroundColor: 'rgba(255,255,255,0.03)',
        borderRadius: 10,
        margin: 12,
        marginTop: 8,
    },
    lineSelected: {
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
        borderWidth: 1,
        borderColor: 'rgba(99, 102, 241, 0.3)',
    },
    priceLeft: {
        flex: 1,
    },
    lineDisplayRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    lineValue: {
        color: '#fff',
        fontSize: 22,
        fontWeight: '700',
    },
    mainBadgeSmall: {
        backgroundColor: 'rgba(46, 125, 50, 0.3)',
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
    },
    mainBadgeSmallText: {
        color: '#4CAF50',
        fontSize: 9,
        fontWeight: '700',
    },
    // Yes/No badges for binary markets
    yesNoBadge: {
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 6,
        marginLeft: 8,
    },
    yesBadge: {
        backgroundColor: 'rgba(16, 185, 129, 0.25)',
        borderWidth: 1,
        borderColor: 'rgba(16, 185, 129, 0.5)',
    },
    noBadge: {
        backgroundColor: 'rgba(239, 68, 68, 0.25)',
        borderWidth: 1,
        borderColor: 'rgba(239, 68, 68, 0.5)',
    },
    yesNoBadgeText: {
        color: '#fff',
        fontSize: 12,
        fontWeight: '700',
    },
    bookCountText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        marginTop: 2,
    },
    priceRight: {
        alignItems: 'flex-end',
        marginRight: 16,
    },
    priceValue: {
        color: '#fff',
        fontSize: 22,
        fontWeight: '700',
    },
    impliedText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        marginTop: 2,
    },
    stackedLogos: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    stackedLogo: {
        width: 28,
        height: 28,
        borderRadius: 14,
        borderWidth: 2,
        borderColor: 'rgba(30, 30, 45, 1)',
    },
    moreLogos: {
        width: 28,
        height: 28,
        borderRadius: 14,
        backgroundColor: 'rgba(255,255,255,0.1)',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 2,
        borderColor: 'rgba(30, 30, 45, 1)',
    },
    moreLogosText: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 9,
        fontWeight: '700',
    },
    
    // Side switch (Over | Under, − | +) — one card holds both sides
    sideSwitchRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    sideSwitchBtn: {
        minWidth: 56,
        minHeight: 32,
        paddingHorizontal: 12,
        alignItems: 'center',
        justifyContent: 'center',
    },
    sideSwitchText: {
        fontSize: 12,
        fontWeight: '700',
    },

    // Alt Toggle
    altToggle: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 16,
        paddingVertical: 10,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    altToggleLeft: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    altBadgeSmall: {
        backgroundColor: 'rgba(249, 115, 22, 0.2)',
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
        marginRight: 8,
    },
    altBadgeSmallText: {
        color: '#F97316',
        fontSize: 9,
        fontWeight: '800',
    },
    altToggleText: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 12,
    },
    
    // Alt Lines Section - Increased height for better visibility
    altLinesSection: {
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
        maxHeight: 320,
        paddingHorizontal: 12,
        paddingVertical: 8,
    },
    // ⭐ Empty filter state
    emptyFilterState: {
        padding: 24,
        alignItems: 'center',
        justifyContent: 'center',
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    emptyFilterText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 13,
        marginTop: 8,
        marginBottom: 12,
    },
    clearFiltersBtn: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 6,
    },
    clearFiltersBtnText: {
        color: '#fff',
        fontSize: 12,
        fontWeight: '600',
    },
    // ⭐ Line Controls Section - Compact layout
    lineControlsSection: {
        backgroundColor: 'rgba(0,0,0,0.2)',
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    lineControlsTopRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 8,
    },
    lineControlsLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
        flex: 1,
    },
    lineControlInline: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    lineControlLabelInline: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 10,
        fontWeight: '600',
    },
    lineControlButtonsInline: {
        flexDirection: 'row',
        gap: 3,
    },
    lineControlRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
    },
    lineControlLabel: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        fontWeight: '600',
        minWidth: 70,
    },
    lineControlButtons: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 4,
        flex: 1,
    },
    lineControlBtn: {
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 5,
        backgroundColor: 'rgba(255,255,255,0.08)',
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.1)',
    },
    lineControlBtnSmall: {
        paddingHorizontal: 6,
        paddingVertical: 3,
    },
    lineControlBtnHover: {
        backgroundColor: 'rgba(255,255,255,0.12)',
        borderColor: 'rgba(255,255,255,0.18)',
    },
    rowHover: {
        backgroundColor: 'rgba(255,255,255,0.03)',
    },
    lineControlBtnActive: {
        backgroundColor: 'rgba(99, 102, 241, 0.3)',
        borderColor: 'rgba(99, 102, 241, 0.5)',
    },
    lineControlBtnText: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 9,
        fontWeight: '600',
    },
    lineControlBtnTextActive: {
        color: '#fff',
    },
    // Main Only Toggle - Compact right-aligned
    mainOnlyToggle: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 6,
        backgroundColor: 'rgba(255,255,255,0.05)',
    },
    mainOnlyToggleActive: {
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
    },
    mainOnlyToggleText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 9,
        fontWeight: '600',
    },
    mainOnlyToggleTextActive: {
        color: '#fff',
    },
    toggleSwitchSmall: {
        width: 28,
        height: 16,
        borderRadius: 8,
        backgroundColor: 'rgba(255,255,255,0.15)',
        padding: 2,
        justifyContent: 'center',
    },
    toggleSwitchSmallActive: {
        backgroundColor: 'rgba(99, 102, 241, 0.5)',
    },
    toggleKnobSmall: {
        width: 12,
        height: 12,
        borderRadius: 6,
        backgroundColor: 'rgba(255,255,255,0.6)',
    },
    toggleKnobSmallActive: {
        backgroundColor: '#fff',
        marginLeft: 'auto',
    },
    lineControlToggle: {
        justifyContent: 'space-between',
        paddingVertical: 6,
        paddingHorizontal: 4,
        borderRadius: 6,
        marginBottom: 0,
    },
    lineControlToggleActive: {
        backgroundColor: 'rgba(99, 102, 241, 0.1)',
    },
    toggleSwitch: {
        width: 36,
        height: 20,
        borderRadius: 10,
        backgroundColor: 'rgba(255,255,255,0.15)',
        padding: 2,
        justifyContent: 'center',
    },
    toggleSwitchActive: {
        backgroundColor: 'rgba(99, 102, 241, 0.5)',
    },
    toggleKnob: {
        width: 16,
        height: 16,
        borderRadius: 8,
        backgroundColor: 'rgba(255,255,255,0.6)',
    },
    toggleKnobActive: {
        backgroundColor: '#fff',
        marginLeft: 'auto',
    },
    altLineRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderRadius: 8,
        marginBottom: 4,
        backgroundColor: 'rgba(255,255,255,0.02)',
    },
    altLineRowHovered: {
        backgroundColor: 'rgba(255,255,255,0.06)',
    },
    selectedAltLineRow: {
        backgroundColor: 'rgba(139, 92, 246, 0.15)',
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.3)',
    },
    altLineLeft: {
        flex: 1,
    },
    altLineValue: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 15,
        fontWeight: '600',
    },
    altLineBooks: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 10,
        marginTop: 2,
    },
    altLineMetaRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    highBookCount: {
        color: '#10B981',
        fontWeight: '600',
    },
    lowBookCount: {
        color: '#F59E0B',
    },
    // ⭐ Requested line highlighting
    requestedLineHighlight: {
        backgroundColor: 'rgba(16, 185, 129, 0.15)',
        borderWidth: 1,
        borderColor: 'rgba(16, 185, 129, 0.4)',
    },
    requestedLineText: {
        color: '#10B981',
        fontWeight: '700',
    },
    requestedBadge: {
        backgroundColor: 'rgba(16, 185, 129, 0.25)',
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: 'rgba(16, 185, 129, 0.5)',
    },
    requestedBadgeText: {
        color: '#10B981',
        fontSize: 8,
        fontWeight: '800',
        letterSpacing: 0.5,
    },
    altLinePrice: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 15,
        fontWeight: '600',
    },
    altLineValueRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
    },
    lineBadge: {
        paddingHorizontal: 5,
        paddingVertical: 2,
        borderRadius: 3,
    },
    mainBadgeMini: {
        backgroundColor: 'rgba(46, 125, 50, 0.25)',
    },
    altBadgeMini: {
        backgroundColor: 'rgba(230, 81, 0, 0.25)',
    },
    lineBadgeText: {
        fontSize: 8,
        fontWeight: '700',
        color: 'rgba(255,255,255,0.7)',
    },
    
    // SGP Legs
    sgpLegsSection: {
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
        padding: 12,
    },
    sgpLegsTitle: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        fontWeight: '600',
        marginBottom: 8,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    sgpLegRow: {
        paddingVertical: 6,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.04)',
    },
    sgpLegMarket: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 10,
    },
    sgpLegSelection: {
        color: '#fff',
        fontSize: 13,
        fontWeight: '500',
    },
    
    // EV Methods Section
    evMethodsSection: {
        padding: 12,
        backgroundColor: 'rgba(0,0,0,0.15)',
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    evMethodsTitle: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 10,
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: 8,
    },
    evMethodsRow: {
        flexDirection: 'row',
    },
    evMethodCol: {
        flex: 1,
        alignItems: 'center',
    },
    evMethodLabel: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 10,
        marginBottom: 4,
    },
    evMethodValue: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '700',
    },
    evMethodUsed: {
        color: '#10B981',
        fontSize: 9,
        fontWeight: '600',
        marginTop: 2,
    },
    
    // Sportsbooks (Right Column)
    sportsbooksHeader: {
        flexDirection: 'column',
        alignItems: 'stretch',
        padding: 10,
        paddingBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.06)',
        gap: 6,
    },
    sportsbooksTitle: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 12,
        fontWeight: '600',
        textAlign: 'center',
    },
    sortButtonsRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 4,
        flexWrap: 'wrap',
    },
    sortButton: {
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 4,
        backgroundColor: 'rgba(255,255,255,0.05)',
    },
    sortButtonActive: {
        backgroundColor: 'rgba(99, 102, 241, 0.3)',
    },
    sortButtonHovered: {
        backgroundColor: 'rgba(255,255,255,0.12)',
    },
    sortButtonText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 10,
        fontWeight: '600',
    },
    sortButtonTextActive: {
        color: '#fff',
    },
    sportsbooksList: {
        flex: 1,
    },
    sportsbookRow: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.04)',
    },
    sportsbookHighlighted: {
        backgroundColor: 'rgba(162, 89, 255, 0.15)',
    },
    sportsbookRowHovered: {
        backgroundColor: 'rgba(255,255,255,0.07)',
    },
    sportsbookClickable: {
        backgroundColor: 'rgba(16, 185, 129, 0.05)',
    },
    sportsbookSelected: {
        backgroundColor: 'rgba(99, 102, 241, 0.2)',
        borderLeftWidth: 3,
        borderLeftColor: '#6366F1',
    },
    bookSelectedIndicator: {
        marginRight: 6,
    },
    sportsbookNameSelected: {
        color: '#fff',
        fontWeight: '600',
    },
    sportsbookLogo: {
        width: 28,
        height: 28,
        borderRadius: 6,
        marginRight: 10,
    },
    sportsbookLogoPlaceholder: {
        width: 28,
        height: 28,
        borderRadius: 6,
        backgroundColor: 'rgba(255,255,255,0.1)',
        marginRight: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    sportsbookLogoText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 12,
        fontWeight: '700',
    },
    sportsbookInfo: {
        flex: 1,
        minWidth: 0,
    },
    sportsbookNameRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    sportsbookName: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 12,
        marginBottom: 2,
    },
    sportsbookNameClickable: {
        color: '#10B981',
    },
    sportsbookNameSelected: {
        color: '#fff',
        fontWeight: '600',
    },
    sportsbookPrice: {
        color: '#fff',
        fontSize: 14,
        fontWeight: '700',
    },
    sportsbookEvContainer: {
        marginLeft: 8,
        minWidth: 45,
        alignItems: 'flex-end',
    },
    sportsbookEvValue: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        fontWeight: '600',
    },
    betLinkIndicator: {
        width: 24,
        height: 24,
        borderRadius: 12,
        backgroundColor: 'rgba(16, 185, 129, 0.15)',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 4,
    },
    noLinkIndicator: {
        width: 24,
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 4,
    },
    noLinkText: {
        color: 'rgba(255,255,255,0.2)',
        fontSize: 12,
    },
    scrollIndicator: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        paddingVertical: 6,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
        backgroundColor: 'rgba(0,0,0,0.2)',
    },
    scrollIndicatorText: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 10,
        fontWeight: '500',
    },
    
    // Legacy sportsbooks toggle (for mobile)
    sportsbooksToggle: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        paddingVertical: 10,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    sportsbooksToggleText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 12,
    },
    
    // Math Section
    mathToggle: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        paddingVertical: 10,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    mathToggleHovered: {
        backgroundColor: 'rgba(255,255,255,0.04)',
    },
    mathToggleText: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 12,
    },
    mathSection: {
        padding: 12,
        backgroundColor: 'rgba(0,0,0,0.2)',
    },
    mathRow: {
        flexDirection: 'row',
        marginBottom: 12,
    },
    mathCol: {
        flex: 1,
        alignItems: 'center',
    },
    mathLabel: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 10,
        marginBottom: 4,
        textTransform: 'uppercase',
    },
    mathValue: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '600',
    },
    mathSub: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 10,
        marginTop: 2,
    },
    stakeInput: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        color: '#fff',
        fontSize: 16,
        fontWeight: '600',
        paddingHorizontal: 12,
        paddingVertical: 6,
        borderRadius: 6,
        textAlign: 'center',
        minWidth: 60,
    },
    
    // Team Logos
    teamLogosRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        paddingVertical: 12,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    teamLogo: {
        width: 36,
        height: 36,
        borderRadius: 8,
    },
    vsText: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 12,
    },
    
    // Actions
    actions: {
        flexDirection: 'row',
        padding: 12,
        gap: 8,
        borderTopWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.06)',
    },
    actionButton: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 12,
        borderRadius: 10,
        backgroundColor: 'rgba(255,255,255,0.08)',
        gap: 6,
    },
    selectButton: {
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
    },
    selectButtonActive: {
        backgroundColor: 'rgba(16, 185, 129, 0.15)',
    },
    actionText: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 14,
        fontWeight: '600',
    },
    actionTextActive: {
        color: '#10B981',
    },
    betNowButtonActive: {
        backgroundColor: 'rgba(16, 185, 129, 0.15)',
        borderWidth: 1,
        borderColor: 'rgba(16, 185, 129, 0.3)',
    },
    betNowButtonHovered: {
        backgroundColor: 'rgba(16, 185, 129, 0.28)',
        borderColor: 'rgba(16, 185, 129, 0.55)',
    },
    betNowTextActive: {
        color: '#10B981',
    },
    selectButtonHovered: {
        backgroundColor: 'rgba(99, 102, 241, 0.28)',
        borderWidth: 1,
        borderColor: 'rgba(99, 102, 241, 0.5)',
    },
});
